import { forwardRef } from "react";
import Form from "react-bootstrap/Form";
import { FormControlProps } from "react-bootstrap/FormControl";
import { KeyValue } from "../../../models/key-value";
import { PropsWithClassName } from "../../../models/props-with-class-name";

export type SelectInputProps = PropsWithClassName<{
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  items?: KeyValue<string>[];
  placeholder?: string;
}> &
  FormControlProps;

const SelectInput = forwardRef(
  (
    {
      value,
      items,
      onChange,
      placeholder,
      isInvalid,
      className,
      ...rest
    }: SelectInputProps,
    ref
  ) => {
    return (
      <Form.Control
        as="select"
        className={`app-form-input px-1 app-form-input-dropdown ${className} 
        ${isInvalid ? "invalid" : ""} ${value && "value-selected"}`}
        value={value || "-1"}
        onChange={onChange}
        size="sm"
        ref={ref}
        {...rest}
      >
        {placeholder && (
          <option value="-1" disabled hidden>
            {placeholder}
          </option>
        )}
        {items?.map((item) => (
          <option key={item.key} value={item.key}>
            {item.value}
          </option>
        ))}
      </Form.Control>
    );
  }
);

export default SelectInput;
